import { LinearProgress } from '@material-ui/core';

const ProgressBar = LinearProgress;

export default ProgressBar;
